import { inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AppCartItemsService } from '../../../app-cart-items.service';
import { isPlatformServer } from '@angular/common';

export const cartItemExistsGuardFn: CanActivateFn = (routeSnapshot: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  // CartItems are stored in sessionStorage; guard will be executed again on the browser
  if (isPlatformServer(platformId)) {
    return true;
  }
  const cartItemsService = inject(AppCartItemsService);

  const { cartItemId } = routeSnapshot.params;

  const cartItem = cartItemsService.findCartItem(cartItemId);

  if (!cartItem) {
    return router.createUrlTree(['/']);
  }
  return true;
};
